import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import AppNavigator from './navigation/AppNavigator';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import FeedScreen from './screens/FeedScreen';
import LoopsScreen from './screens/LoopsScreen';
import ProfileScreen from './screens/ProfileScreen';
import CreatePostScreen from './screens/CreatePostScreen';
import SearchScreen from './screens/SearchScreen';
import ChatScreen from './screens/ChatScreen';
import NotificationsScreen from './screens/NotificationsScreen';
import UserProfileScreen from './screens/UserProfileScreen';
import AboutPage from './screens/AboutPage';
import HelpPage from './screens/HelpPage';
import SettingsPage from './screens/SettingsPage';
import TermsPage from './screens/TermsPage';
import PrivacyPage from './screens/PrivacyPage';
import LoadingSpinner from './components/LoadingSpinner';
import styled from 'styled-components';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #000;
`;

const App = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <AppContainer>
      <Routes>
        {isAuthenticated ? (
          <>
            <Route path="/" element={<AppNavigator />}>
              <Route index element={<Navigate to="/feed" replace />} />
              <Route path="feed" element={<FeedScreen />} />
              <Route path="loops" element={<LoopsScreen />} />
              <Route path="profile" element={<ProfileScreen />} />
              <Route path="search" element={<SearchScreen />} />
              <Route path="create" element={<CreatePostScreen />} />
              <Route path="chat" element={<ChatScreen />} />
              <Route path="notifications" element={<NotificationsScreen />} />
              <Route path="user/:userId" element={<UserProfileScreen />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="help" element={<HelpPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="terms" element={<TermsPage />} />
              <Route path="privacy" element={<PrivacyPage />} />
            </Route>
          </>
        ) : (
          <>
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/register" element={<RegisterScreen />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </AppContainer>
  );
};

export default App; 